import { ApolloError } from '@apollo/client';

export interface SubjectSaveError {
  title: string;
  description?: string;
  technicalDetails: string;
  isConflict: boolean;
}

const getErrorContent = (error: unknown) => {
  if (!(error instanceof ApolloError)) {
    const message = error instanceof Error ? error.message : 'Erreur inconnue';
    return { message, haystack: message };
  }

  const [graphqlError] = error.graphQLErrors;
  const message = graphqlError?.message || error.message;
  const stacktrace = Array.isArray(graphqlError?.extensions?.stacktrace)
    ? graphqlError.extensions.stacktrace.join('\n')
    : '';

  return {
    code: graphqlError?.extensions?.code as string | undefined,
    message,
    haystack: [message, stacktrace, error.networkError?.message]
      .filter(Boolean)
      .join('\n'),
  };
};

export const getSubjectSaveError = (
  error: unknown,
  subjectTitle: string,
): SubjectSaveError => {
  const { code, message, haystack } = getErrorContent(error);
  const technicalDetails = [
    code && `Code : ${code}`,
    message && `Message : ${message}`,
  ]
    .filter(Boolean)
    .join('\n');

  if (
    code === 'CONFLICT' ||
    code === 'DUPLICATE' ||
    /duplicate entry|er_dup_entry|unique.?constraint/i.test(haystack)
  ) {
    const title = subjectTitle.trim();
    return {
      title: title
        ? `Un sujet nommé « ${title} » existe déjà.`
        : 'Un sujet portant cet intitulé existe déjà.',
      description:
        'Choisissez un autre intitulé, ou modifiez le sujet existant.',
      technicalDetails,
      isConflict: true,
    };
  }

  return {
    title: 'Erreur lors de la sauvegarde du sujet.',
    technicalDetails: technicalDetails || 'Erreur inconnue',
    isConflict: false,
  };
};
